/* Top level history page. This page should get all titles from MongoDB and show them. Upon
   clicking on a title, a component should then show that entry. That component should be
   re-used on any page where a history entry needs to be shown. */

import React, { useEffect, useState }  from 'react'
import Axios                           from 'axios'
import Box                             from "@material-ui/core/Box"
import Paper                           from "@material-ui/core/Paper"

import HistoryTitles                   from '../Components/HistoryTitles'
import HistoryUpdateComponent          from '../Components/HistoryUpdateComponent'

import { CLIENT_PUBLIC_TOKEN }         from '../config'
import { node_server }                 from '../Helpers'

const HistoryUpdatePage = () => {

   const [ showHistoryUpdateComponent, setShowHistoryUpdateComponent  ]  =  useState(false)

   const handleClick = (t) => {
      console.log('You click on', t)
      setShowHistoryUpdateComponent(true)
   }

   const handleShow = () => {
      setShowHistoryUpdateComponent(false)
   }

   return (
      <Box>
         {showHistoryUpdateComponent
            ?
               <HistoryUpdateComponent handleShow={handleShow} />
            :
               <Paper style={{ marginTop: '50px', margin: '20px', backgroundColor: 'rgba(0, 0, 255, 0.05)' }} >
                  <HistoryTitles handleClick={handleClick} />
               </Paper>
         }
      </Box>
   )
}

export default HistoryUpdatePage
